module.exports = __webpack_public_path__ + "static/media/sc_25_i.2efb6d20.png";